import styled from 'styled-components';

export const Text = styled.p<{
  size?: string;
  color?: string;
  weight?: string;
  align?: string;
}>`
  font-size: ${(props) => props.size || '1rem'};
  color: ${(props) => props.color || '#4b5563'};
  font-weight: ${(props) => props.weight || '400'};
  margin-bottom: 0.5rem;
  line-height: 1.5;
  font-family: 'Inter', sans-serif;
  text-align: ${(props) => props.align || 'left'};

  @media (max-width: 768px) {
    font-size: ${(props) => {
  const baseSize = props.size || '1rem';
  return `calc(${baseSize} * 0.9)`;
}};
  }
`;
